/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cloud_logic_custom": [
        {
            "name": "pythonapi",
            "endpoint": "https://51yi9oxsre.execute-api.eu-central-1.amazonaws.com/production",
            "region": "eu-central-1"
        }
    ]
};


export default awsmobile;
